<template xmlns:v-bind="http://www.w3.org/1999/xhtml" xmlns:v-el="http://www.w3.org/1999/xhtml">
  <svg
    viewBox="0 0 180 149"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink">
    <!-- Generator: Sketch 64 (93537) - https://sketch.com -->
    <title>auto-intenders</title>
    <desc>Created with Sketch.</desc>
    <g
      id="Page-1"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd">
      <g
        id="Desktop-HD"
        transform="translate(-324.000000, -225.000000)">
        <g
          id="auto-intenders"
          transform="translate(325.000000, 225.000000)">
          <g id="New_Symbol_83-15">
            <path
              id="Path"
              d="M170.818215,81.8181818 C170.815052,48.4048854 150.49458,18.3508104 119.487669,5.90011177 C88.480759,-6.55058691 53.0184679,1.10414626 29.9081796,25.2363439 C6.79789129,49.3685415 0.683780904,85.1286685 14.4636364,115.568182 L163.536364,115.568182 C168.345764,104.967218 170.828731,93.459086 170.818215,81.8181818 Z"
              class="fill-extra-light"
              fill-rule="nonzero" />
            <line
              id="Path"
              x1="9.22727273"
              y1="115.568182"
              x2="168.772727"
              y2="115.568182"
              class="stroke"
              stroke-width="2.04545455"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <line
              id="Path"
              x1="0.0227272727"
              y1="115.568182"
              x2="5.13636364"
              y2="115.568182"
              class="stroke"
              stroke-width="2.04545455"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <line
              id="Path"
              x1="172.863636"
              y1="115.568182"
              x2="177.977273"
              y2="115.568182"
              class="stroke"
              stroke-width="2.04545455"
              stroke-linecap="round"
              stroke-linejoin="round" />
          </g>
          <circle
            id="Oval"
            class="stroke fill-light"
            stroke-width="2.04545455"
            fill-rule="nonzero"
            stroke-linecap="round"
            stroke-linejoin="round"
            cx="83.8863636"
            cy="107.386364"
            r="8.18181818" />
          <circle
            id="Oval"
            class="stroke fill-light"
            stroke-width="2.04545455"
            fill-rule="nonzero"
            stroke-linecap="round"
            stroke-linejoin="round"
            cx="138.090909"
            cy="107.386364"
            r="8.18181818" />
          <circle
            id="Oval"
            class="stroke fill-white"
            stroke-width="2.04545455"
            fill-rule="nonzero"
            stroke-linecap="round"
            stroke-linejoin="round"
            cx="83.8863636"
            cy="107.386364"
            r="5.11363636" />
          <circle
            id="Oval"
            class="stroke fill-white"
            stroke-width="2.04545455"
            fill-rule="nonzero"
            stroke-linecap="round"
            stroke-linejoin="round"
            cx="138.090909"
            cy="107.386364"
            r="4.09090909" />
          <path
            id="Path"
            d="M60.8136364,109.063636 C60.7032441,109.666446 60.8689523,110.286994 61.2651633,110.754523 C61.6613743,111.222052 62.2463381,111.487297 62.8590909,111.477547 L71.8181818,111.477547 C72.3547861,111.475013 72.8690123,111.261977 73.25,110.884091 L74.1090909,110.025 C74.4951067,109.642118 75.0176757,109.428675 75.5613636,109.431818 L92.2727273,109.431818 C92.8093316,109.434078 93.3235578,109.647114 93.7045455,110.025 L94.5636364,110.884091 C94.9496522,111.266972 95.4722212,111.480416 96.0159091,111.477547 L126.493182,111.477547 C127.331417,111.478084 128.085308,110.967384 128.395455,110.188636 L130.952273,103.827273 C131.572566,102.269778 133.080348,101.248377 134.756818,101.25 L141.486364,101.25 C143.155369,101.256734 144.652931,102.276695 145.270455,103.827273 L147.827273,110.188636 C148.137419,110.967384 148.89131,111.478084 149.729545,111.477547 L154.761364,111.477547 C155.781316,111.488803 156.653881,110.747123 156.806818,109.738636 L158.177273,100.902273 C158.392631,99.2492532 157.583449,97.6308886 156.131818,96.8113636 L153.431818,95.1136364 L153.186364,94.0909091 C152.735166,92.265863 151.098174,90.9832713 149.218182,90.9818182 L125.818182,90.9818182 L122.218182,85.6022727 C120.640364,83.2330171 117.944535,81.8541157 115.1,81.9613636 L106.325,82.2886364 C97.6006904,82.6473013 89.0524547,84.8575711 81.2477273,88.7727273 L76.7272727,91.0227273 L70.5909091,92.925 C66.2267546,94.2615588 62.9648144,97.9095741 62.1227273,102.395455 L60.8136364,109.063636 Z"
            class="fill-white"
            fill-rule="nonzero" />
          <path
            id="Path"
            d="M60.8136364,109.063636 C60.7032441,109.666446 60.8689523,110.286994 61.2651633,110.754523 C61.6613743,111.222052 62.2463381,111.487297 62.8590909,111.477547 L71.8181818,111.477547 C72.3547861,111.475013 72.8690123,111.261977 73.25,110.884091 L74.1090909,110.025 C74.4951067,109.642118 75.0176757,109.428675 75.5613636,109.431818 L92.2727273,109.431818 C92.8093316,109.434078 93.3235578,109.647114 93.7045455,110.025 L94.5636364,110.884091 C94.9496522,111.266972 95.4722212,111.480416 96.0159091,111.477547 L126.493182,111.477547 C127.331417,111.478084 128.085308,110.967384 128.395455,110.188636 L130.952273,103.827273 C131.572566,102.269778 133.080348,101.248377 134.756818,101.25 L141.486364,101.25 C143.155369,101.256734 144.652931,102.276695 145.270455,103.827273 L147.827273,110.188636 C148.137419,110.967384 148.89131,111.478084 149.729545,111.477547 L154.761364,111.477547 C155.781316,111.488803 156.653881,110.747123 156.806818,109.738636 L158.177273,100.902273 C158.392631,99.2492532 157.583449,97.6308886 156.131818,96.8113636 L153.431818,95.1136364 L153.186364,94.0909091 C152.735166,92.265863 151.098174,90.9832713 149.218182,90.9818182 L125.818182,90.9818182 L122.218182,85.6022727 C120.640364,83.2330171 117.944535,81.8541157 115.1,81.9613636 L106.325,82.2886364 C97.6006904,82.6473013 89.0524547,84.8575711 81.2477273,88.7727273 L76.7272727,91.0227273 L70.5909091,92.925 C66.2267546,94.2615588 62.9648144,97.9095741 62.1227273,102.395455 L60.8136364,109.063636 Z"
            class="stroke"
            stroke-width="2.04545455"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <path
            id="Path"
            d="M153.431818,95.1136364 L113.709091,96.1363636 C112.286993,96.1872724 110.93612,96.7714338 109.925,97.7727273 L109.925,97.7727273 C108.961648,98.7315368 107.681668,99.3060732 106.325,99.3886364 L73.5977273,101.147727 C71.669524,101.254103 69.9038848,102.261957 68.8318182,103.868182 L66.5,107.386364"
            class="stroke"
            stroke-width="2.04545455"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <path
            id="Path"
            d="M100.740909,86.85 L116.593182,85.9090909 C117.247656,85.8748171 117.878922,86.156225 118.290909,86.6659091 L121.727273,91.0227273 L98.2045455,91.0227273 L98.8590909,88.4045455 C99.0745776,87.5278659 99.8393139,86.8961272 100.740909,86.85 L100.740909,86.85 Z"
            class="fill-light"
            fill-rule="nonzero" />
          <path
            id="Path"
            d="M107.940909,86.4409091 L116.593182,85.9090909 C117.247656,85.8748171 117.878922,86.156225 118.290909,86.6659091 L121.727273,91.0227273 L112.522727,91.0227273 L107.940909,86.4409091 Z"
            class="fill-white"
            fill-rule="nonzero" />
          <path
            id="Path"
            d="M100.740909,86.85 L116.593182,85.9090909 C117.247656,85.8748171 117.878922,86.156225 118.290909,86.6659091 L121.727273,91.0227273 L98.2045455,91.0227273 L98.8590909,88.4045455 C99.0745776,87.5278659 99.8393139,86.8961272 100.740909,86.85 L100.740909,86.85 Z"
            class="stroke"
            stroke-width="2.04545455"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <path
            id="Path"
            d="M96.1590909,86.9318182 L95.1363636,91.0227273 L84.9090909,91.0227273 C84.9090909,91.0227273 92.2931818,86.9318182 96.1590909,86.9318182 Z"
            class="stroke fill-light"
            stroke-width="2.04545455"
            fill-rule="nonzero"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <path
            id="Path"
            d="M151.202273,108.654545 C151.307503,109.111361 151.715318,109.434215 152.184091,109.431831 L158.545455,109.431831 C159.675128,109.431831 160.590909,108.516037 160.590909,107.386364 L160.590909,107.386364 C160.590909,106.25669 159.675128,105.340909 158.545455,105.340909 L151.672727,105.340909 C151.360201,105.344272 151.066367,105.490355 150.875036,105.737491 C150.683704,105.984627 150.61588,106.305686 150.690909,106.609091 L151.202273,108.654545 Z"
            class="stroke fill-light"
            stroke-width="2.04545455"
            fill-rule="nonzero"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <path
            id="Path"
            d="M59.3409091,109.431818 L66.725,109.431818 C67.196321,109.428902 67.6071388,109.110308 67.7272727,108.654545 L68.2386364,106.609091 C68.3062594,106.303128 68.2327661,105.982973 68.0384739,105.737134 C67.8441816,105.491294 67.5496723,105.345813 67.2363636,105.340909 L59.3409091,105.340909 C58.2112357,105.340909 57.2954545,106.25669 57.2954545,107.386364 L57.2954545,107.386364 C57.2954545,108.516037 58.2112357,109.431818 59.3409091,109.431818 Z"
            class="stroke fill-light"
            stroke-width="2.04545455"
            fill-rule="nonzero"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <polyline
            id="Path"
            class="stroke"
            stroke-width="2.04545455"
            stroke-linecap="round"
            stroke-linejoin="round"
            points="121.727273 91.0227273 124.795455 96.1363636 121.727273 111.477273" />
          <line
            id="Path"
            x1="98.2045455"
            y1="91.0227273"
            x2="98.2045455"
            y2="111.477273"
            class="stroke"
            stroke-width="2.04545455"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <path
            id="Path"
            d="M76.0727273,136.534091 L77.2386364,136.534091 C78.479925,136.534738 79.6995924,136.859043 80.7772727,137.475 L80.7772727,100.063636 L50.1363636,100.063636 L50.1363636,137.475 C51.2058268,136.857155 52.4194414,136.532583 53.6545455,136.534091 L54.8409091,136.534091 C57.289948,136.539897 59.5629806,137.807847 60.8545455,139.888636 L61.7545455,114.177273 C61.7545455,112.155157 63.3937938,110.515909 65.4159091,110.515909 C67.4380244,110.515909 69.0772727,112.155157 69.0772727,114.177273 L69.9977273,139.888636 C71.2921506,137.78019 73.5988001,136.506485 76.0727273,136.534091 L76.0727273,136.534091 Z"
            class="fill-white"
            fill-rule="nonzero" />
          <path
            id="Path"
            d="M61.9590909,103.602273 C61.9590909,106.200521 59.8527942,108.306818 57.2545455,108.306818"
            class="stroke"
            stroke-width="2.04545455"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <path
            id="Path"
            d="M69.0159091,103.602273 C69.0159091,106.200521 71.1222058,108.306818 73.7204545,108.306818"
            class="stroke"
            stroke-width="2.04545455"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <path
            id="Path"
            d="M76.0727273,136.534091 L77.2386364,136.534091 C78.479925,136.534738 79.6995924,136.859043 80.7772727,137.475 L80.7772727,100.063636 L50.1363636,100.063636 L50.1363636,137.475 C51.2058268,136.857155 52.4194414,136.532583 53.6545455,136.534091 L54.8409091,136.534091 C57.289948,136.539897 59.5629806,137.807847 60.8545455,139.888636 L61.7545455,114.177273 C61.7545455,112.155157 63.3937938,110.515909 65.4159091,110.515909 C67.4380244,110.515909 69.0772727,112.155157 69.0772727,114.177273 L69.9977273,139.888636 C71.2921506,137.78019 73.5988001,136.506485 76.0727273,136.534091 L76.0727273,136.534091 Z"
            class="stroke"
            stroke-width="2.04545455"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <ellipse
            id="Oval"
            class="fill-extra-light"
            fill-rule="nonzero"
            cx="65.4772727"
            cy="144.756818"
            rx="30.5795455"
            ry="3.53863636" />
          <path
            id="Path"
            d="M81.3090909,143.590909 C82.153429,143.587565 82.9323797,143.135773 83.3545455,142.404545 C83.7753503,141.684227 83.7753503,140.793045 83.3545455,140.072727 C82.0952567,137.874528 79.7515126,136.522969 77.2181818,136.534091 L76.0522727,136.534091 C73.5177999,136.518657 71.1720381,137.87138 69.9159091,140.072727 C69.4870909,140.798188 69.4870909,141.699539 69.9159091,142.425 C70.3370663,143.154586 71.1189969,143.600287 71.9613636,143.590909 L81.3090909,143.590909 Z"
            class="stroke fill-light"
            stroke-width="2.04545455"
            fill-rule="nonzero"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <path
            id="Path"
            d="M58.9727273,143.590909 C59.8205314,143.600545 60.6055619,143.145227 61.0181818,142.404545 C61.4478078,141.68664 61.4478078,140.790633 61.0181818,140.072727 C59.7652391,137.868211 57.4174379,136.514312 54.8818182,136.534091 L53.6954545,136.534091 C51.1621237,136.522969 48.8183797,137.874528 47.5590909,140.072727 C47.1433776,140.801172 47.1469747,141.695859 47.568532,142.420938 C47.9900893,143.146017 48.765827,143.591785 49.6045455,143.590909 L58.9727273,143.590909 Z"
            class="stroke fill-light"
            stroke-width="2.04545455"
            fill-rule="nonzero"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <path
            id="Path"
            d="M71.3681818,100.063636 L80.8181818,102.436364 C91.0454545,95.5431818 90.2272727,81.2659091 90.2272727,81.2659091 C90.486113,72.2723743 85.8359674,63.8489842 78.0876164,59.2758318 C70.3392654,54.7026794 60.7175527,54.7026794 52.9692018,59.2758318 C45.2208508,63.8489842 40.5707052,72.2723743 40.8295455,81.2659091 C40.8295455,81.2659091 39.9909091,95.5840909 50.2386364,102.436364 L59.6477273,100.063636 L71.3681818,100.063636 Z"
            class="fill-light"
            fill-rule="nonzero" />
          <path
            id="Path"
            d="M59.6068182,100.063636 C52.1818182,95.2772727 50.1363636,75.375 50.1363636,75.375"
            class="stroke"
            stroke-width="2.04545455"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <path
            id="Path"
            d="M71.3681818,100.063636 C78.7727273,95.2772727 80.8181818,75.375 80.8181818,75.375"
            class="stroke"
            stroke-width="2.04545455"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <path
            id="Path"
            d="M71.3681818,100.063636 L80.8181818,102.436364 C91.0454545,95.5431818 90.2272727,81.2659091 90.2272727,81.2659091 C90.486113,72.2723743 85.8359674,63.8489842 78.0876164,59.2758318 C70.3392654,54.7026794 60.7175527,54.7026794 52.9692018,59.2758318 C45.2208508,63.8489842 40.5707052,72.2723743 40.8295455,81.2659091 C40.8295455,81.2659091 39.9909091,95.5840909 50.2386364,102.436364 L59.6477273,100.063636 L71.3681818,100.063636 Z"
            class="stroke"
            stroke-width="2.04545455"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <line
            id="Path"
            x1="65.4772727"
            y1="85.95"
            x2="65.4772727"
            y2="100.063636"
            class="stroke"
            stroke-width="2.04545455"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <path
            id="Path"
            d="M72.3704545,57.5590909 C67.872217,56.2222944 63.0823285,56.2222944 58.5840909,57.5590909 L65.4772727,85.9090909 L72.3704545,57.5590909 Z"
            class="stroke fill-white"
            stroke-width="2.04545455"
            fill-rule="nonzero"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <path
            id="Path"
            d="M65.4772727,63.6136364 C68.2363421,63.6315549 70.7497513,62.0306573 71.9,59.5227273 L72.3704545,57.6409091 C67.872217,56.3041126 63.0823285,56.3041126 58.5840909,57.6409091 L59.0545455,59.5227273 C60.2128939,62.0235851 62.7211879,63.6212246 65.4772727,63.6136364 Z"
            class="stroke fill-white"
            stroke-width="2.04545455"
            fill-rule="nonzero"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <path
            id="Path"
            d="M77.0340909,101.495455 C77.0340909,101.495455 77.0340909,101.945455 77.0340909,102.661364"
            class="stroke"
            stroke-width="2.04545455"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <path
            id="Path"
            d="M77.4227273,106.854545 C77.9954545,111.170455 79.4681818,116.55 83.1295455,116.55 C87.3431818,116.55 84.6840909,111.006818 82.5772727,107.55"
            class="stroke"
            stroke-width="2.04545455"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-dasharray="1.840909042141654" />
          <line
            id="Path"
            x1="81.4318182"
            y1="105.75"
            x2="80.8181818"
            y2="104.788636"
            class="stroke"
            stroke-width="2.04545455"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <path
            id="Path"
            d="M81.9431818,37.7386364 C81.929467,36.3583056 80.9461383,35.1783112 79.5909091,34.9159091 L79.5909091,33.0340909 C79.5909091,25.2393448 73.2720189,18.9204545 65.4772727,18.9204545 C57.6825266,18.9204545 51.3636364,25.2393448 51.3636364,33.0340909 L51.3636364,34.9159091 C49.9475296,35.1875678 48.9496552,36.4633393 49.0270664,37.903188 C49.1044776,39.3430367 50.2333843,40.5044651 51.6704545,40.6227273 C53.0338109,47.1676557 58.8020809,51.8581721 65.4875,51.8581721 C72.1729191,51.8581721 77.9411891,47.1676557 79.3045455,40.6227273 C80.7916655,40.476496 81.9294549,39.2328657 81.9431818,37.7386364 L81.9431818,37.7386364 Z"
            class="stroke fill-white"
            stroke-width="2.04545455"
            fill-rule="nonzero"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <path
            id="Path"
            d="M81.9431818,37.7386364 C81.929467,36.3583056 80.9461383,35.1783112 79.5909091,34.9159091 L79.5909091,33.0340909 C79.5909091,25.2393448 73.2720189,18.9204545 65.4772727,18.9204545 C57.6825266,18.9204545 51.3636364,25.2393448 51.3636364,33.0340909 L51.3636364,34.9159091 C49.9475296,35.1875678 48.9496552,36.4633393 49.0270664,37.903188 C49.1044776,39.3430367 50.2333843,40.5044651 51.6704545,40.6227273 C53.0338109,47.1676557 58.8020809,51.8581721 65.4875,51.8581721 C72.1729191,51.8581721 77.9411891,47.1676557 79.3045455,40.6227273 C80.7916655,40.476496 81.9294549,39.2328657 81.9431818,37.7386364 L81.9431818,37.7386364 Z"
            class="stroke"
            stroke-width="2.04545455"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <path
            id="Path"
            d="M60.1795455,33.0340909 C59.4579354,33.0341386 58.807792,33.4699575 58.5335937,34.1374426 C58.2593955,34.8049278 58.4154326,35.57192 58.9286288,36.0792175 C59.4418251,36.5865149 60.2105699,36.7336749 60.8748406,36.4517786 C61.5391114,36.1698824 61.9673853,35.5147442 61.9590909,34.7931818 C61.9478854,33.8183633 61.1544284,33.0340265 60.1795455,33.0340909 L60.1795455,33.0340909 Z"
            fill="#0066A4"
            fill-rule="nonzero" />
          <path
            id="Path"
            d="M70.775,33.0340909 C69.7988556,33.0792539 69.0417429,33.9030936 69.0789938,34.8795719 C69.1162447,35.8560502 69.9339217,36.6198145 70.9106698,36.5904781 C71.887418,36.5611417 72.6577835,35.7496811 72.6363636,34.7727273 C72.6363636,33.8012082 71.8487918,33.0136364 70.8772727,33.0136364 L70.775,33.0340909 Z"
            fill="#0066A4"
            fill-rule="nonzero" />
          <circle
            id="Oval"
            class="fill-light"
            fill-rule="nonzero"
            cx="57.8272727"
            cy="39.4977273"
            r="1.75909091" />
          <circle
            id="Oval"
            class="fill-light"
            fill-rule="nonzero"
            cx="73.1272727"
            cy="39.4977273"
            r="1.75909091" />
          <path
            id="Path"
            d="M61.9590909,43.7318182 C64.0990508,45.145208 66.8759492,45.145208 69.0159091,43.7318182"
            class="stroke"
            stroke-width="2.04545455"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <path
            id="Path"
            d="M54.2272727,25.9363636 C52.7073214,25.815721 51.2695099,25.197462 50.1363636,24.1772727 L50.1363636,33.0340909 C50.130876,33.3468379 50.2512856,33.6486735 50.4705336,33.8717679 C50.6897816,34.0948623 50.9894776,34.2204546 51.3022727,34.2204546 L51.6909091,34.2204546 C52.1723814,34.2115823 52.600726,33.9125493 52.775,33.4636364 L55.025,27.8590909 C54.6731836,27.2572957 54.404817,26.6104632 54.2272727,25.9363636 Z"
            class="stroke fill-white"
            stroke-width="2.04545455"
            fill-rule="nonzero"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <path
            id="Path"
            d="M80.8181818,23.625 C80.8181818,18.4285026 76.6055883,14.2159091 71.4090909,14.2159091 L60.7727273,14.2159091 C59.4736029,14.2159091 58.4204545,13.1627607 58.4204545,11.8636364 L54.9022727,11.8636364 C51.1673206,11.9057629 48.1121002,14.8510129 47.9331471,18.5819133 C47.754194,22.3128137 50.5134988,25.536958 54.2272727,25.9363636 C54.8926888,28.4624371 57.0174626,30.3367623 59.6068182,30.6818182 L62.7568182,30.6818182 C62.8639996,30.6762451 62.9551314,30.6016827 62.9818182,30.4977273 C63.0095028,30.3854679 62.9475967,30.2704995 62.8386364,30.2318182 C61.1051377,29.4935044 59.9236753,27.85521 59.7704545,25.9772727 L71.3681818,25.9772727 L78.0772727,32.7272727 C78.2920641,32.9486053 78.5870354,33.0739681 78.8954545,33.075 L79.5909091,33.075 C80.2382141,33.075 80.7661123,32.5562997 80.7772727,31.9090909 L80.8181818,23.625 Z"
            class="fill-white"
            fill-rule="nonzero" />
          <path
            id="Path"
            d="M80.8181818,23.625 C80.8181818,18.4285026 76.6055883,14.2159091 71.4090909,14.2159091 L60.7727273,14.2159091 C59.4736029,14.2159091 58.4204545,13.1627607 58.4204545,11.8636364 L54.9022727,11.8636364 C51.1673206,11.9057629 48.1121002,14.8510129 47.9331471,18.5819133 C47.754194,22.3128137 50.5134988,25.536958 54.2272727,25.9363636 C54.8926888,28.4624371 57.0174626,30.3367623 59.6068182,30.6818182 L62.7568182,30.6818182 C62.8639996,30.6762451 62.9551314,30.6016827 62.9818182,30.4977273 C63.0095028,30.3854679 62.9475967,30.2704995 62.8386364,30.2318182 C61.1051377,29.4935044 59.9236753,27.85521 59.7704545,25.9772727 L71.3681818,25.9772727 L78.0772727,32.7272727 C78.2920641,32.9486053 78.5870354,33.0739681 78.8954545,33.075 L79.5909091,33.075 C80.2382141,33.075 80.7661123,32.5562997 80.7772727,31.9090909 L80.8181818,23.625 Z"
            class="stroke"
            stroke-width="2.04545455"
            stroke-linecap="round"
            stroke-linejoin="round" />
        </g>
      </g>
    </g>
  </svg>
</template>

<style lang="scss" rel="stylesheet/scss" scoped>
  @use '@/styles/variables.scss' as *;

  .fill-extra-light {
    fill: var(--iconColorFaded9);
  }

  .stroke {
    stroke: var(--iconColor);
  }

  .fill-light {
    fill: var(--iconColorFaded6);
  }

  .fill-white {
    fill: #ffffff;
  }
</style>
